import { ChartData, ChartOptions } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';
import merge from 'lodash/merge';
import { useTheme } from 'src/providers/ThemeProvider';
import { CHART_GRID, CHART_TICK, chartMode } from 'src/styles/chartTheme';
import { localeNumber } from 'src/localization/locale';

export const defaultAreaChartOptions: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
      labels: { boxWidth: 12, boxHeight: 12, usePointStyle: true, color: CHART_TICK },
    },
    tooltip: {
      enabled: true,
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
  },
  elements: {
    point: { radius: 0, hoverRadius: 5 },
    line: { tension: 0.3, borderWidth: 2 },
  },
  hover: { mode: 'nearest', intersect: false },
  scales: {
    x: {
      stacked: true,
      grid: { drawOnChartArea: false, color: 'rgba(0, 0, 0, 0)' },
      border: { display: false },
      ticks: { padding: 9, color: CHART_TICK, autoSkip: true, maxRotation: 0 },
    },
    y: {
      stacked: true,
      min: 0,
      ticks: { padding: 9, color: CHART_TICK, callback: value => localeNumber(Number(value)) },
      border: { display: false },
    },
  },
};

const AreaChart: React.FC<{
  data: ChartData<'line', number[], string>;
  options?: Partial<ChartOptions<'line'>>;
}> = ({ data, options }) => {
  const { theme } = useTheme();
  const gridColor = CHART_GRID[chartMode(theme)];
  const mergedOptions = merge({}, defaultAreaChartOptions, { scales: { y: { grid: { color: gridColor } } } }, options);
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', contain: 'inline-size' }}>
      <Line data={data} options={mergedOptions} height="auto" width="auto" />
    </div>
  );
};

export default AreaChart;
